import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plus, Users } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

const spanFor = (i) => {
  const pattern = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6", "md:col-span-5", "md:col-span-7"];
  return pattern[i % pattern.length];
};

function Card({ item, index }) {
  const { addItem } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className={`group relative col-span-12 ${spanFor(index)} overflow-hidden rounded-[2rem] border border-black/10 bg-white`}
      data-testid={`item-card-${item.id}`}
    >
      <div className="relative h-56 md:h-72 overflow-hidden">
        <img
          src={item.image}
          alt={item.name}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-700 uppercase tracking-wide">
          {item.category}
        </span>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display font-800 text-2xl tracking-tight">{item.name}</h3>
            <p className="mt-1 flex items-center gap-1.5 text-sm text-ink/50 font-500">
              <Users size={14} /> {item.capacity}
            </p>
          </div>
          <div className="text-right shrink-0">
            <div className="font-display font-900 text-2xl text-brand-coral leading-none">${item.price_per_day}</div>
            <div className="text-xs text-ink/50 font-500">/ {item.unit}</div>
          </div>
        </div>
        <p className="mt-3 text-sm text-ink/70 font-500 leading-relaxed">{item.description}</p>
        <button
          onClick={() => addItem(item)}
          className="group/btn mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-ink text-white py-3 font-700 hover:bg-brand-coral transition-colors"
          data-testid={`add-item-${item.id}`}
        >
          <Plus size={18} className="transition-transform group-hover/btn:rotate-90" /> Add to Booking
        </button>
      </div>
    </motion.div>
  );
}

export default function Inventory() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/items").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="inventory" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="text-sm font-700 uppercase tracking-widest text-brand-coral">The Inventory</span>
            <h2 className="mt-2 font-display font-900 tracking-tight text-4xl md:text-6xl leading-none">
              Pick your party gear.
            </h2>
          </div>
          <p className="max-w-sm text-ink/60 font-500">
            Every rental is cleaned, inspected & delivered on time. Add what you love, choose your dates, done.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {items.map((item, i) => (
            <Card key={item.id} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
